import { Navigate, useLocation } from 'react-router-dom';

const MobileProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('mobileToken');

  if (!token) {
    return <Navigate to="/mobile/login" state={{ from: location }} replace />;
  }

  return children;
};

export default MobileProtectedRoute;
